'use client';

import { ReactNode } from 'react';

import { useConsents } from '@/providers/consents';

const ConsentSettings = ({ children }: { children: ReactNode }) => {
  const { consentSettingsOpen } = useConsents();

  if (!consentSettingsOpen) return null;

  return children;
};

export default ConsentSettings;
